module.exports = __webpack_public_path__ + "img/envelopes-bulk.e9841d01.svg";